import { RiVipCrownFill } from "react-icons/ri";
import {
  AiTwotoneSound,
  AiFillDollarCircle,
  AiOutlineClear,
} from "react-icons/ai";
import { HiOutlineClipboardList } from "react-icons/hi";
import { TbPokerChip, TbMessage, TbMoneybag } from "react-icons/tb";
import { IoGift, IoSettings, IoWallet } from "react-icons/io5";
import { FaHeadphonesAlt } from "react-icons/fa";
import { HiShare } from "react-icons/hi";
import {
  closeColorMode,
  openCache,
  openChat,
  openColorMode,
  openLanguagePop,
} from "../../redux/action/member/memberAction";
import { MdOutlineLanguage } from "react-icons/md";
import { IoIosMoon, IoIosSend } from "react-icons/io";
import ThemeTab from "../../pages/Settings/components/themeTab";
import { useSelector } from "react-redux";

const iconStyle = "text-2xl mr-[10px]";

const isCredit = process.env.REACT_APP_CREDIT == "1";

export const MENU_LIST = ({ className, dispatch }) => {
  const isMemberInfo = useSelector((state) => state.isMemberInfo);
  return {
    basic: [
      {
        icon: IoIosSend,
        text: "Send-Points",
        link: "send-points",
        iconColor: "#963EFF",
        auth: true,
        verify: isMemberInfo?.is_turnover != 1,
        hidden: isCredit,
      },
      {
        icon: IoIosSend,
        text: "Rebate",
        link: "my-rebate",
        iconColor: "#963EFF",
        auth: true,
        hidden: !isCredit,
      },
    ],
    message: [
      {
        icon: IoGift,
        text: "Reward",
        link: "rewards",
        iconColor: "#6448FF",
        auth: true,
        hidden: isCredit,
      },

      {
        icon: TbMessage,
        text: "Inbox",
        link: "inbox",
        iconColor: "#3FAD66",
        auth: true,
      },
    ],
    setting: [
      {
        icon: IoSettings,
        text: "Settings",
        link: "settings",
        iconColor: "#88919A",
        auth: true,
      },
      {
        icon: FaHeadphonesAlt,
        text: "serviceInformation",
        link: "../service-group",
        func: () => {
          dispatch(openChat());
        },
        iconColor: "#88919A",
        hidden: isCredit,
      },
      {
        icon: AiOutlineClear,
        text: "ClearCache",
        link: "clear-cache",
        func: () => {
          dispatch(openCache());
        },
        iconColor: "#88919A",
      },

      {
        icon: MdOutlineLanguage,
        text: "Language",
        link: "language",
        func: () => {
          dispatch(openLanguagePop());
        },
        border: true,
        iconColor: "#88919A",
      },
      {
        icon: IoIosMoon,
        text: "Color-Mode",
        link: "color-mode",
        func: () => {
          dispatch(openColorMode());
        },
        border: true,
        iconColor: "#88919A",
      },
    ],
  };
};
